import { Pipe, PipeTransform } from '@angular/core';
import * as marked from "marked";
import { MenusService } from './services/menus.service';
/** Transformer le markdown en html */
@Pipe({
  name: 'mark'
})
export class MarkPipe implements PipeTransform {

  transform(value: any): any {
    console.log("Text markdown", value);
    if (value && value.length > 0) {
      return marked(value);
    }
    return value;
  }

}
/** Récupérer les articles en fonctions de la langue */
@Pipe({
  name: 'lang'
})
export class LangPipe implements PipeTransform {

  transform(values: any[], l:string=null): any {
    if (!values || !values.length) return [];
    if (!l) return values;

    return values.filter(v => {
      // Filtre sur le titre
      if(v.langue.code.indexOf(l) >= 0){
        return v;
      }
    });
  }

}
/** Récupérer les articles en fonctions de la langue */
@Pipe({
  name: 'couleur'
})
export class CouleurPipe implements PipeTransform {

  constructor(private s:MenusService) {}

  transform(l:string=null): any {
    if (!l) return '#F7C45F';

    return this.s.couleurs[parseInt(l)-1].code || '#F7C45F';
  }

}